import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push, replace } from 'connected-react-router'

import { storeAccessToken } from '../../../services/data/accessToken'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import { setDevice } from '../../../modules/device/actions/creators'
import { setLoyaltyPoints } from '../../../modules/loyalty/actions/creators'

import { doGoogleLogin, doAppleLogin } from '../../../controllers/Login'

import {
  doSavePrimaryInfo,
  // doSavePrimaryInfoV1,
  doValidateRegistrationForm,
} from '../../../controllers/Registration'

import {
  doGetFirebaseToken,
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

import { setPrimaryInfo } from '../../../modules/profile/actions/creators'

import {
  setStep,
  setToken,
  setGoogleToken,
  setAppleToken,
} from '../../../modules/registration/actions/creators'
import {
  setAccessToken,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'

import MainView from '../components/MainView/MainView'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}

const mapStateToProps = reduxState => {
  const { profile, registration, auth, device: deviceModule } = reduxState
  const { primaryInfo } = profile
  const { token, step, googleToken, appleToken, referralCode } = registration
  const { firebaseMessagingToken } = auth
  const { browser } = deviceModule

  return {
    primaryInfo,
    token,
    step,
    googleToken,
    appleToken,
    referralCode,
    firebaseMessagingToken,
    browser,
    doSavePrimaryInfo: doSavePrimaryInfo,
    // doSavePrimaryInfo: doSavePrimaryInfoV1,
    doGoogleLogin,
    doAppleLogin,
    doValidateRegistrationForm,
    doGetFirebaseToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setDevice,
      setPrimaryInfo,
      setStep,
      setToken,
      push,
      replace,
      setGoogleToken,
      setAppleToken,
      saveAccessToken,
      setAccessToken,
      setFirebaseMessagingToken,
      setLoyaltyPoints,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
